"use strict";

/**
 * 优品上报js
 */
;(function () {
    window.upStatApi = {};
    var testHost = "upstat.test.upchina.com/log";
    var productionHost = "weblog.upfintech.com/log";
    var protocol = location.protocol + "//";
    var host = testHost;
    var uuid = guid();

    /**
     * 获取用户信息
     */
    function init(option) {
        var rsp = {
            ret: 0,
            message: 'success'
        };
        var env = option.env || 'test';
        if (env != "test") {
            host = productionHost;
        }

        var cronDurationStat = option.cronDurationStat || false;
        var statIntervalTime = option.statIntervalTime || 3000;
        console.log("---------cronDurationStat-----", cronDurationStat, "---------statIntervalTime----------", statIntervalTime);
        if (cronDurationStat) {
            cronReport(option);
            reportPVUV(option);
            setInterval(function () {
                cronReport(option);
            }, statIntervalTime);
        } else {
            reportPVUV(option);
        }
    }

    function reportEvent(option) {
        var reportUrl = encodeURIComponent(window.location.href);
        var title = document.title;
        var firstEventKey = option.firstEventKey; // 一级事件key
        var firstEventName = option.firstEventName; // 一级事件名
        var firstEventValue = option.firstEventValue; // 一级事件值

        var secondEventKey = option.secondEventKey; // 二级事件key
        var secondEventName = option.secondEventName; // 二级事件名
        var secondEventValue = option.secondEventValue; // 二级事件值

        var thirdEventKey = option.thirdEventKey; // 三级事件key
        var thirdEventName = option.thirdEventName; // 三级事件名
        var thirdEventValue = option.thirdEventValue; // 三级事件值

        var eventKey = option.eventKey; // 事件key
        var eventName = option.eventName; //事件名
        var eventTime = option.eventTime; //事件时间
        var eventType = option.eventType; // sum avg sumkey avgKey
        var eventValue = option.eventValue || 1;
        var jumpurl = option.jumpurl; //跳转地址
        var userName = option.userName;
        var guid = option.guid;
        var xua = option.xua;
        var url = protocol + host + "?url=" + reportUrl + "&uuid=" + uuid + "&business_type=web";;
        if (userName) {
            url = url + "&uid=" + userName;
        }
        if (guid) {
            url = url + "&guid=" + guid;
        }
        if (xua) {
            url = url + "&xua=" + xua;
        }
        if (title) {
            url = url + "&desc=" + title;
        }
        if (eventKey && eventName && eventTime && eventType) {
            url = url + "&type=" + eventType + "&ek1=" + eventKey + "&ev1=" + eventValue + "&en1=" + eventName + "&time=" + eventTime;
            if (firstEventKey && firstEventName && firstEventValue) {
                url = url + "&ek2=" + firstEventKey + "&en2=" + firstEventName + "&ev2=" + firstEventValue;
            }
            if (secondEventKey && secondEventName && secondEventValue) {
                url = url + "&ek3=" + secondEventKey + "&en3=" + secondEventName + "&ev3=" + secondEventValue;
            }
            if (thirdEventKey && thirdEventName && thirdEventValue) {
                url = url + "&ek4=" + thirdEventKey + "&en4=" + thirdEventName + "&ev4=" + thirdEventValue;
            }
            if (jumpurl) {
                url = url + "&jumpurl=" + jumpurl;
            }
            new Image().src = "" + url;
        }
        // $.ajax({
        //     type: "get",
        //     url:url,
        //     success: function (data, status, xhr) {
        //         console.log("========reportEvent success=========",data);
        //     },
        //     error: function (xhr, errorType, err) {
        //         console.log("========reportEvent error=========",err);
        //     }
        // });
    }

    function cronReport(option) {
        var userName = option.userName;
        var guid = option.guid;
        var xua = option.xua;
        var statIntervalTime = option.statIntervalTime || 3000;
        var reportUrl = encodeURIComponent(window.location.href);
        var title = document.title;
        var url = protocol + host + "?url=" + reportUrl + "&uuid=" + uuid + "&type=duration&ek1=duration&ev1=" + statIntervalTime + "&business_type=web";
        if (userName) {
            url = url + "&uid=" + userName;
        }
        if (guid) {
            url = url + "&guid=" + guid;
        }
        if (xua) {
            url = url + "&xua=" + xua;
        }
        if (title) {
            url = url + "&title=" + title;
        }
        new Image().src = "" + url;
        // $.ajax({
        //     type: "get",
        //     url:url,
        //     success: function (data, status, xhr) {
        //         console.log("========cronReport success=========",data);
        //     },
        //     error: function (xhr, errorType, err) {
        //         console.log("========cronReport error=========",err);
        //     }
        // });
    }

    function reportPVUV(option) {
        var userName = option.userName;
        var xua = option.xua;
        var guid = option.guid;
        var reportUrl = encodeURIComponent(window.location.href);
        var title = document.title;
        var eventType = "pv";
        var url = protocol + host + "?url=" + reportUrl + "&uuid=" + uuid + "&business_type=web";;
        if (userName) {
            url = url + "&uid=" + userName;
            eventType = "pvuv";
        }
        if (guid) {
            url = url + "&guid=" + guid;
        }
        if (xua) {
            url = url + "&xua=" + xua;
        }
        if (title) {
            url = url + "&title=" + title;
        }
        url = url + "&type=" + eventType;
        new Image().src = "" + url;
        // $.ajax({
        //     type: "get",
        //     url:url,
        //     success: function (data, status, xhr) {
        //         console.log("========reportPVUV success=========",data);
        //     },
        //     error: function (xhr, errorType, err) {
        //         console.log("========reportPVUV error=========",err);
        //     }
        // });
    }

    function guid() {
        function S4() {
            return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
        }
        return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
    }

    window.upStatApi.init = init; //初始化
    window.upStatApi.reportEvent = reportEvent; //事件上报
})();